export default "__VITE_ASSET__BlKoZ8Ow__"